import React from 'react';
import { BsPlus, BsTrash } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Flex, Icon, IconButton } from '@chakra-ui/react';

import TabButton from '../../../../components/TabMenu/TabButton';
import {
  deleteAutomation,
  selectCurrentAutomation,
  selectEmailAutomations,
  setCurrentAutomation
} from '../../../../redux/modules/emailAutomations';
import { hideModal, showConfirmModal, showModal } from '../../../../redux/modules/modal';

import CreateAutomationModal from './CreateAutomationModal';

const AutomationSidePanel = wrapperStyles => {
  const dispatch = useDispatch();
  const emailAutomations = useSelector(selectEmailAutomations);
  const currentAutomation = useSelector(selectCurrentAutomation);

  const openCreateModal = () => {
    dispatch(showModal(CreateAutomationModal, {
      size: 'md',
      title: 'New Automation'
    }));
  };

  const handleDeleteAutomationClick = automation => e => {
    e.stopPropagation();

    dispatch(showConfirmModal(`Delete ${automation.name}`, () => {
      dispatch(deleteAutomation(automation.id));
      dispatch(hideModal());
    }));
  };

  return (
    <Box {...wrapperStyles}>
      <Button
        as={Flex}
        cursor="pointer"
        justifyContent="flex-start"
        leftIcon={<Icon as={BsPlus} boxSize="20px" />}
        px={0}
        textAlign="left"
        variant="textPrimary"
        width="100%"
        onClick={openCreateModal}
      >
        New Automation
      </Button>

      {emailAutomations.map((emailAutomation, idx) => (
        <TabButton
          description={emailAutomation.description}
          idx={idx}
          isActive={currentAutomation.id === emailAutomation.id}
          key={emailAutomation.id}
          tabId={emailAutomation.id}
          textAlign="left"
          title={emailAutomation.name}
          onClick={() => dispatch(setCurrentAutomation(emailAutomation))}
        >
          <IconButton
            alignSelf="flex-end"
            aria-label={`Delete ${emailAutomation.name}`}
            as={BsTrash}
            color="red.500"
            size="xs"
            variant="ghost"
            onClick={handleDeleteAutomationClick(emailAutomation)}
          >
            Delete Automation
          </IconButton>
        </TabButton>
      ))}
    </Box>
  );
};

export default AutomationSidePanel;
